import React, { useCallback, useState, } from 'react'
import { Box, Typography, Divider, Paper, Grid, 
} from '@mui/material';

import CommissionModel from './commission-model';
import LibrarySelect from 'components/librarySelect';
import SeatSharingCard from './seat-sharing/SeatSharingCard';

const RevenueSharing = () => {

  const [librarySelected, setLibrarySelected] = useState({});

  const onLibrarySelected = useCallback((lib) => {
    setLibrarySelected(lib);
  },[]);

  
  return ( 
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={4} >
          <Grid item xs={6} sm={6} md={6} xl={4} lg={4}>
            <Typography component="h2" variant="h6" color="typography.heading"  gutterBottom sx={{mb: 1}}>
              Revenue Sharing
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} md={6} xl={8} lg={8}  sx={{display: 'flex'}} justifyContent="flex-end">
            <LibrarySelect onLibrarySelected={onLibrarySelected}/>
          </Grid>
        </Grid>
        <Divider />
        <Grid container columnSpacing={4} rowSpacing={4} sx={{mt: 1 }} alignItems="center" justifyContent="space-evenly" >
          <Grid item xs={12} sm={9} md={6} xl={4} lg={4} >
            <SeatSharingCard library={librarySelected}/>
          </Grid>
          <Grid item xs={12} sm={9} md={6} xl={4} lg={4} >
            <CommissionModel library={librarySelected}/>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default RevenueSharing;
